import { PopupOverlay } from './overlays/PopupOverlay.js';

class ProductPopups {
  constructor(map) {
    this.map = map;
    this.overlay = new PopupOverlay({ 
      positioning: "bottom-left",
      offset: [-50, -15],
      elementId: 'popup',
      pagination: true,
    });
    /*
    overlay = new PopupOverlay({
      element: document.getElementById(overlayConfig.elementId),
      autoPan: overlayConfig.autoPan,
      autoPanAnimation: {
        duration: overlayConfig.autoPanAnimationDuration,
      },
      idPrefix: overlayConfig.idPrefix,
      labelSource: overlayConfig.labelSource,
      dataSource: overlayConfig.dataSource,
      dataKeys: overlayConfig.dataKeys,
      template: overlayConfig.template,
      pagination: overlayConfig.pagination,
    });
    */
    this.map.addOverlay(this.overlay);
  }

  addPopups(productConfig) {
    this.overlay.addPopups(productConfig);
  }

  removePopups(productConfig) {
    this.overlay.removePopups(productConfig);
  }
}

export default ProductPopups;